import { StateParams, StateProvider } from "@uirouter/angularjs";
import { vsComponentName as processGridComponentName } from "./views/ProcessInstancesGrid";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";
import { processInstancesName } from "./config/objects";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "./services/processInformationService";
import { ProcessGroup, ProcessInformation } from "./model/ProcessGroups";
import { IPromise, IScope, Injectable } from "angular";
import { IGridSettings } from "../records/grids/settings/gridSettingsService";
import { ColDef } from "../records/grids/columns/colDef";

routeConfig.$inject = ["$stateProvider"];

const baseRoute = "main.processes";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state(baseRoute, {
      abstract: true,
      template: "<ui-view></ui-view>",
      url: "processes",
    })
    .state(`${baseRoute}.grid`, {
      url: "",
      component: processGridComponentName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(processInstancesName),
        ],
        processGroups: [
          ProcessInformationServiceName,
          (processInformationService: ProcessInformationService) =>
            processInformationService.getAuthorizedGetProcessGroups(),
        ],
      },
    })
    .state(`${baseRoute}.grid.group`, {
      url: "/{groupName:string}",
      template:
        require("!html-loader!./views/ProcessInstancesGrid/groupTemplate.html")
          .default,
      controller: [
        "$scope",
        "processGroup",
        "gridSettings",
        "additionalGridColumns",
        ProcessInformationServiceName,
        (
          s: IScope,
          processGroup: ProcessGroup,
          gridSettings: IGridSettings,
          additionalGridColumns: ColDef[],
          processInformationService: ProcessInformationService
        ) => {
          const $scope = <any>s;
          $scope.processGroup = processGroup;
          $scope.gridSettings = gridSettings;
          $scope.onNewProcessSelected = (process: ProcessInformation) =>
            ProcessInformationService.createNewProcessFlow(
              processInformationService,
              processGroup,
              process
            );
          $scope.defaultQuery = undefined;
          $scope.additionalGridColumns = additionalGridColumns;
        },
      ],
      resolve: {
        processGroup: [
          "$stateParams",
          ProcessInformationServiceName,
          (
            $stateParams: StateParams,
            processInformationService: ProcessInformationService
          ) =>
            processInformationService.getProcessGroup($stateParams.groupName),
        ],
        gridSettings: [
          ProcessInformationServiceName,
          "processGroup",
          (
            processInformationService: ProcessInformationService,
            processGroup: ProcessGroup
          ) => processInformationService.getGridSettings(processGroup),
        ],
        additionalGridColumns: [
          "processGroup",
          ProcessInformationServiceName,
          (
            processGroup: ProcessGroup,
            processInformationService: ProcessInformationService
          ) => processInformationService.getAdditionalGridColumns(processGroup),
        ],
      },
    });
}
